import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

// PLUGINS
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { Facebook } from '@ionic-native/facebook/ngx';
import { FCM } from 'plugins/cordova-plugin-fcm-with-dependecy-updated/ionic/ngx/FCM';
import { SignInWithApple } from '@ionic-native/sign-in-with-apple/ngx';
import { CommercePage } from './commerce/commerce.page';
import { Globals } from './globals';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AdressPageModule } from './adress/adress.module';
import { AdressPage } from './adress/adress.page';
import { ValorationPageModule } from './valoration/valoration.module';
import { Tab1Page } from './tab1/tab1.page';

// PIPE
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { Device } from '@ionic-native/device/ngx';
import { RegisterPage } from './register/register.page';
import { MapComponent } from './map/map.component';
import { FormsModule } from '@angular/forms';
import { NewMapComponent } from './new-map/new-map.component';
import { NewAddressComponent } from './new-address/new-address.component';
import { IonicStorageModule } from '@ionic/storage-angular';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);


@NgModule({
  declarations: [AppComponent, NewMapComponent, MapComponent, NewAddressComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    FormsModule,    
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    StatusBar,
    SplashScreen,
    Geolocation,
    NativeStorage,
    CallNumber,
    Facebook,
    FCM,
    NativeGeocoder,
    InAppBrowser,
    SignInWithApple,
    CommercePage,
    Globals,
    AdressPageModule,
    AdressPage,
    ValorationPageModule,
    Tab1Page,
    Device,
    RegisterPage,
    MapComponent,
    NewMapComponent,

    NewAddressComponent,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
